module.exports = "/_next/static/images/2-8e71c1c14e1c9f5892fe2e481805d07e.jpg";